import { Input, Tables } from '@ixyberfree/ixybercomponents';
import '@ixyberfree/ixybercomponents/dist/esm/index.css';
import * as React from 'react';
import { IPens } from './index';
import './TrendsTable.css';

interface ITrendsTable {
    items: IPens[];
    calbackEditItem: any;
    UpdateEnableState: any;
    UpdateMin: any;
    UpdateMax: any;
    calbackClickRow: any;
}

export interface ITrendView {
    selected?: boolean;
    param: string;
    curvalue?: string;
    desc?: string;
    eudesc?: string;
    min?: any;
    max?: any;
    color?: any;
    enable: boolean;
}

interface ColumnData {
    dataKey: string;
    label: string;
    numeric?: boolean;
    width: any;
    minWidth?: any;
}

interface Row {
    index: number;
}

export default function TrendsTable(props: ITrendsTable) {
    let Test: boolean = false;

    const UpdateTableInterval = 1000;

    const Update = () => {
        try {
            let cloneHmiHistory = props.items.slice();
            for (let param = cloneHmiHistory.length; param--; ) {
                let parnew = window.parent.GetParam(cloneHmiHistory[param].name);
                cloneHmiHistory[param].curvalue = Number(parnew.V).toFixed(3);
                // cloneHmiHistory[param].max = Number(props.items[param].max).toFixed(3);
                // cloneHmiHistory[param].min = Number(props.items[param].min).toFixed(3);
            }
            // setItems(cloneHmiHistory);
        } catch (ex) {}
    };

    useInterval(Update, UpdateTableInterval);

    function Checked() {
        const checkedIds: string[] = [];

        props.items.forEach((item, index) => {
            if (item.enable === true) {
                checkedIds.push(index.toString());
            }
        });

        return checkedIds;
    }

    function UpdateState(item: { id: any }, checked: any) {
        const newId = Number(item.id) + 1;
        props.UpdateEnableState(newId, checked);
    }

    return (
        <div style={{ height: '100%', minWidth: '100%', overflowX: 'auto', overflowY: 'hidden', position: 'inherit' }}>
            <div className="table__trends" style={{ height: '100%', minWidth: '1020px' }}>
                <Tables
                    header={[
                        {
                            idCol: 'select',
                            width: '30px',
                            label: 'selected',
                            type: 'select'
                        },
                        {
                            idCol: 'color',
                            width: '30px',
                            label: '',
                            type: 'text',
                            action: false
                        },
                        {
                            idCol: 'name',
                            width: '230px',
                            label: 'Источник',
                            type: 'text',
                            action: true
                        },
                        {
                            idCol: 'desc',
                            width: '250px',
                            label: 'Описание',
                            type: 'text'
                        },
                        {
                            idCol: 'min',
                            width: '120px',
                            label: 'Мин.',
                            type: 'number'
                        },
                        {
                            idCol: 'max',
                            width: '120px',
                            label: 'Макс.',
                            type: 'number'
                        },
                        {
                            idCol: 'curvale',
                            width: '120px',
                            label: 'Тек. знач.',
                            type: 'number',
                            action: true
                        },
                        {
                            idCol: 'eudesc',
                            width: '120px',
                            label: 'Ед. измер.',
                            type: 'text'
                        }
                    ]}
                    data={props.items.map((item) => ({
                        color: (
                            <div
                                id={String(item.id)}
                                title={item.color}
                                style={{ width: '20px', height: '20px', backgroundColor: item.color }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    props.calbackEditItem(e, item.id);
                                }}></div>
                        ),
                        name: item.name,
                        desc: item.desc,
                        min: (
                            <div onClick={(e) => e.stopPropagation()}>
                                <Input
                                    id={String(item.id)}
                                    width="110px"
                                    type="number"
                                    defaultValue={item.min.toString()}
                                    onBlur={(event) => {
                                        props.UpdateMin(item.id, event.target.value);
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === 'Enter') {
                                            event.currentTarget.blur();
                                        }
                                    }}
                                />
                            </div>
                        ),
                        max: (
                            <div onClick={(e) => e.stopPropagation()}>
                                <Input
                                    id={String(item.id)}
                                    width="110px"
                                    type="number"
                                    defaultValue={item.max.toString()}
                                    onBlur={(event) => {
                                        props.UpdateMax(item.id, event.target.value);
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === 'Enter') {
                                            event.currentTarget.blur();
                                        }
                                    }}
                                />
                            </div>
                        ),
                        curvale: Number(item.curvalue).toFixed(3),
                        eudesc: item.eudesc
                    }))}
                    onCheck={UpdateState}
                    checked={Checked()}
                    cssClassHead="header__style"
                    cssClassBody="body__style"
                    width="100%"
                    // width='1160px'
                    height="100%"
                />
            </div>
        </div>
    );
}

function useInterval(callback: any, delay: any) {
    const savedCallback: any = React.useRef();

    // Remember the latest callback.
    React.useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    React.useEffect(() => {
        function tick() {
            if (savedCallback) savedCallback.current();
        }
        if (delay !== null) {
            let id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay]);
}
